<template>
  <div class="animated fadeIn">
    <b-card>
      <!-- <router-link :to="'/orderForm'" class="btn btn-success pull-right">
        <i class="fa fa-plus"></i>
        Add
      </router-link>-->
      <b-card>
        <b-row>
          <b-col cols="1">{{t(['Date','ວັນທີ'])}}:</b-col>
          <b-col cols="2">
            <datepicker input-class="form-control" :format="'yyyy-MM-dd'" v-model="fromdate" />
          </b-col>
          <b-col cols="2">
            <datepicker input-class="form-control" :format="'yyyy-MM-dd'" v-model="todate" />
          </b-col>
          <b-col>
            <b-button-group>
              <b-button variant="primary" @click="gets()">
                <i class="fa fa-search"></i>
                {{t(['Search','ຊອກຫາ'])}}
              </b-button>
              <ExcelButton :items="orders" />
            </b-button-group>
          </b-col>
        </b-row>
      </b-card>
      <b-tabs>
        <b-tab>
          <template slot="title" :active="status === undefined">
            {{t(['ALL','ທັງໝົດ'])}}
            <b-badge variant="primary">{{orders ? orders.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="orders" />
        </b-tab>

        <b-tab :active="status === 0">
          <template slot="title">
            {{t(['PENDINGS','ເຂົ້າມາໃໝ່'])}}
            <b-badge variant="dark">{{pendings ? pendings.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="pendings" :canAdd="false" />
        </b-tab>

        <b-tab :active="status === 1">
          <template slot="title">
            {{t(['PROCESSINGS','ກຳລັງເຮັດ'])}}
            <b-badge variant="warning">{{processings ? processings.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="processings" />
        </b-tab>

        <b-tab :active="status === 2">
          <template slot="title">
            {{t(['SENDINGS','ກຳລັງໄປສົ່ງ'])}}
            <b-badge variant="primary">{{sendings ? sendings.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="sendings" />
        </b-tab>

        <b-tab :active="status === 3">
          <template slot="title">
            {{t(['COMPLETED','ສົ່ງສຳເລັດ'])}}
            <b-badge variant="success">{{completes ? completes.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="completes" />
        </b-tab>

        <b-tab :active="status === -1">
          <template slot="title">
            {{t(['REJECTED','ຍົກເລີກ'])}}
            <b-badge variant="danger">{{rejects ? rejects.length : 0 | numberformat}}</b-badge>
          </template>
          <OrderTable :items="rejects" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import firebase from "firebase";
import OrderTable from "../../components/OrderTable";
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import Swal from "sweetalert2";
export default {
  name: "Orders",
  components: { OrderTable, Datepicker },
  computed: {
    pendings: function() {
      return _.filter(this.orders, o => o.orderStatus === 0);
    },
    processings: function() {
      return _.filter(this.orders, o => o.orderStatus === 1);
    },
    sendings: function() {
      return _.filter(this.orders, o => o.orderStatus === 2);
    },
    completes: function() {
      return _.filter(this.orders, o => o.orderStatus === 3);
    },
    rejects: function() {
      return _.filter(this.orders, o => o.orderStatus === -1);
    }
  },
  data() {
    return {
      fromdate: new Date(),
      todate: new Date(),
      status: null,
      orders: null,
      collection: firebase.firestore().collection("orders")
    };
  },
  mounted() {
    this.status = this.$route.params.id * 1;
    this.gets();
  },
  methods: {
    gets() {
      Swal.showLoading();
      this.fromdate.setHours(0, 0, 0);
      this.todate.setHours(23, 59, 59);
      this.collection
        .where("createDate", ">=", this.fromdate)
        .where("createDate", "<=", this.todate)
        .orderBy("createDate", "desc")
        .onSnapshot(snapshot => {
          let orders = [];
          snapshot.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            orders.push(item);
          });
          this.orders = orders;
          Swal.close();
        });
    }
  }
};
</script>

<style>
</style>
